import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { rootRoute } from './root';
import { getSession } from '@/lib/auth-client';
import { consoleAccess } from '@/lib/console-admin';
import { PermissionProvider } from '@/lib/permissions';
import { RouteError } from '@/admin/ConsoleRouteError';
import { reportRenderError } from '@/lib/rum';

// The pool-time review page: per-SDR time-in-pool with the day behind each
// number. Lazy-loaded like /responsiveness so the cockpit's chunk never pays
// for it; admin-gated the same way, with the JWT riding per-request on the
// /bff/reports calls.

function PoolTimeGate() {
  const { userEmail, role } = poolTimeRoute.useRouteContext();
  return (
    <PermissionProvider role={role}>
      <LazyPoolTimePage userEmail={userEmail} />
    </PermissionProvider>
  );
}

const LazyPoolTimePage = lazyRouteComponent(() => import('@/admin/PoolTimePage'));

export const poolTimeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/pool-time',
  // Same gate as /console, /live and /responsiveness: this page's /bff/reports/*
  // reads are admin-gated, so a non-admin would get an error wall rather than a
  // page.
  beforeLoad: async () => {
    const { data } = await getSession();
    if (!data) throw redirect({ to: '/login' });
    const { allowed, role } = await consoleAccess();
    if (!allowed) throw redirect({ to: '/' });
    return { userEmail: data.user.email, role };
  },
  component: PoolTimeGate,
  errorComponent: RouteError,
  onCatch: (error) => reportRenderError(error, 'route:pool-time'),
});
